// Meet linkini kişinin kendi Google hesabıyla aç: tarayıcıda birden çok hesap açıksa (ör. kişisel Gmail)
// ?authuser=e-posta Meet'i o hesapla açar.
export function joinUrl(link, email) {
  if (!link) return null;
  if (!email || !/meet\.google\.com/i.test(link)) return link;
  try {
    const u = new URL(link);
    u.searchParams.set('authuser', String(email).trim().toLowerCase());
    return u.toString();
  } catch (e) {
    return link;
  }
}
